import "../../../../assets/scss/styles.scss";
import "./style.scss";
import { useUnderDevelopment } from "./hooks";
import { useElement, useLocale } from "../../../hooks";
export const UnderDevelopment = () => {
  const { t } = useLocale();
  const Button = useElement("Button");
  const Input = useElement("Input");
  const { authenticate } = useUnderDevelopment();
  return (
    <div className="body-background">
      <div className="error-page auth-page">
        <h2 className="fs32 white">{t("maintenance.title")}</h2>
        <p>{t("maintenance.tagline")}</p>
        <div className="form-group">
          <Input
            id="authKey"
            className="input"
            style={{ height: "40px", padding: "10px 20px" }}
          />
        </div>
        <Button className="btn btn-primary" onClick={authenticate}>
          {t("submit")}
        </Button>
      </div>
    </div>
  );
};
